<template>
  <PageContainer>
    <template v-slot:body>
      <Container
        :class="$style.topContainer"
      >
        <Card
          :class="$style.card"
          :noBorder="true"
        >
          <Container
            v-if="!loading"
          >
            <InvoicesTable :tableData="tableData" />
          </Container>
          <LoadingOverlay :visible="loading" />
        </Card>
      </Container>
    </template>
  </PageContainer>
</template>

<script>
import {
  Card,
  Container,
  LoadingOverlay,
  PageContainer,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import InvoicesTable from 'client/Account/InvoicesPage/InvoicesTable.vue';

export default {
  name: 'InvoicesPage',

  components: {
    Card,
    Container,
    LoadingOverlay,
    PageContainer,
    InvoicesTable,
  },

  data: () => ({
    loading: false,
  }),

  computed: {
    tableData() {
      return this.invoicesCollection();
    },
  },

  async created() {
    this.loading = true;

    try {
      await this.fetchCollection();
    } catch (exp) {
      this.triggerErrorAlert('Unable to fetch invoices.');
    } finally {
      this.loading = false;
    }
  },

  methods: {
    ...mapActions('AlertModule', [
      'triggerErrorAlert',
    ]),

    ...mapActions('OrganizationInvoiceCollection', [
      'fetchCollection',
    ]),

    ...mapGetters('OrganizationInvoiceCollection', {
      invoicesCollection: 'getCollection',
    }),
  },
};
</script>

<style module scoped>
.card {
  display: grid;
  grid-template-rows: auto;
}

.header {
  border-bottom: var(--jc-border);
}

.topContainer {
  display: grid;
  height: 100%;
}
</style>
